<script>
import AutoNumeric from 'autonumeric';

export default {
  props:{
    value: [String, Number],
    typeNumber:String
  },
  data(){
    return {
      plugin: null,
    }
  },
  computed:{
    myOption(){
      if (this.typeNumber == "decimal") {
        return {
          decimalCharacter:",",
          digitGroupSeparator:".",
          minimumValue:'0',
          decimalPlaces:'2'
        }
      }else if(this.typeNumber == "number"){
        return {
          decimalCharacter:",",
          digitGroupSeparator:".",
          minimumValue:'0',
          decimalPlaces:'0'
        }
      }else{
        return {
          decimalCharacter:",",
          digitGroupSeparator:".",
          minimumValue:'0',
          decimalPlaces:'0'
        }
      }
    }
  },
  mounted(){
    this.plugin = new AutoNumeric(this.$el, this.myOption)
    $(this.$el).change((e)=>{
      this.$emit("input", e.target.value.toValue());
    })
    if(this.value) this.plugin.set(this.value)
  },
  watch:{
    value(v){
      if(!v) return this.plugin.set("")
      this.plugin.set(v.toValue())
    }
  }
}
</script>

<template>
  <input type="text" autocomplete="off">
</template>